import type { AccountEntityExpandResponse } from "@/shared/generated/ExpHubApi";
import {
  mapToInvoiceEmailVariant,
  type InvoiceEmailVariant,
} from "@/app/gas-shop-app/email-addresses/@types/InvoiceEmailVariant";

export interface AccountEmailAddress {
  id: string;
  email: string;
  invoiceEmailVariant?: InvoiceEmailVariant;
  peppolId?: string; // This is only available on some invoice emails
}

export const mapToAccountEmailAddressType = (
  data: NonNullable<AccountEntityExpandResponse["contactAddresses"]>[number],
): AccountEmailAddress => {
  return {
    email: data.email,
    id: data.partnerId,
    invoiceEmailVariant: mapToInvoiceEmailVariant(data.kind),
    peppolId: data.peppolId,
  };
};
